import { AutoScrollStrategy } from "./AutoScrollStrategy";
import { scrollToElement } from "./scrollToElement";
export function scrollToNextAttribute(activeElement, options) {
    if (!activeElement) {
        return;
    }
    const parentElement = activeElement.closest(".attribute-wrapper");
    if (!parentElement) {
        return;
    }
    const allElements = document.querySelectorAll(`.attribute-wrapper`);
    const parentIndex = Array.from(allElements).indexOf(parentElement);
    if (parentIndex < 0) {
        return;
    }
    if (parentIndex === allElements.length - 1) {
        return;
    }
    const nextElements = Array.from(allElements).slice(parentIndex + 1);
    let nextElement = nextElements[0];
    if (options.strategy === AutoScrollStrategy.NextIncompleteAttribute) {
        const incompleteElement = nextElements.find((element) => element.dataset.isComplete === "false");
        if (incompleteElement) {
            nextElement = incompleteElement;
        }
    }
    if (!nextElement) {
        return;
    }
    scrollToElement(nextElement, options);
}
//# sourceMappingURL=scrollToNextAttribute.js.map